<template>
  <v-flex>
    <v-card color="white" class="rounded">
      <v-card-title class="mb-0">
        <h4 class="subheading">Store Transactions</h4>
        <!-- <v-flex ml-2>
          <v-btn icon @click.stop="loadUserTransactions()" :disabled="loading">
            <v-icon title="Refresh" color="secondary">mdi-refresh</v-icon>
          </v-btn>
        </v-flex> -->
        <v-spacer></v-spacer>
        <v-flex style="flex-grow: 0" v-if="showFilter">
          <v-select
            class="width-max-120px"
            dense
            outline
            single-line
            :items="yearList"
            v-model="selectedYear"
            label="Year"
            @change="changeYear"
            hide-details
          ></v-select>
        </v-flex>
        <v-flex ml-2 style="flex-grow: 0" v-if="showFilter">
          <v-select
            class="width-max-120px"
            dense
            outline
            single-line
            :items="monthList"
            v-model="selectedMonth"
            label="Month"
            @change="changeMonth"
            hide-details
          ></v-select>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex mr-4 style="flex-grow: 0">
          <div
            class="d-flex align-center filter-container"
            @click.stop="showFilter = !showFilter"
          >
            <div>
              <v-icon color="#d13b55" size="20">mdi-tune</v-icon>
            </div>
            <div class="text-main-theme ml-1">Filter</div>
          </div>
        </v-flex>
        <v-flex style="flex-grow: 0">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            outline
            hide-details
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <div>
          <v-data-table
            :headers="headers"
            :items="transactions"
            :loading="loading"
            :search="search"
            item-key="purchaseDate"
            sort-by="purchaseDate"
            hide-actions
            :pagination.sync="pagination"
            class="elevation-1"
          >
            <template v-slot:progress>
              <v-progress-linear
                color="#d13b55"
                height="2"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:items="props">
              <td>
                <div
                  v-for="(oi, index) in props.item.items"
                  :key="index"
                  class="mb-1"
                >
                  <a :href="oi.productType" target="_blank">{{
                    oi.productName
                  }}</a>
                  <div class="caption">
                    SKU: {{ oi.productSku }}, QTY: {{ oi.quantity }}
                  </div>
                </div>
              </td>
              <td class="caption">
                <span class="font-weight-medium">{{
                  props.item.customerName
                }}</span>
                spend
                <span class="font-weight-medium">{{
                  props.item.ovationAmount
                }}</span>
                Ovations
              </td>
              <td>
                {{ props.item.purchaseDate | moment("MM/DD/YYYY h:mm a") }}
              </td>
            </template>
          </v-data-table>
        </div>
        <div class="text-xs-center pt-2" v-if="transactions.length > 0">
          <v-pagination
            color="#d13b55"
            v-model="pagination.page"
            :length="pages"
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import axios from "axios";

export default {
  name: "StoreTransactionsList",
  components: {},
  data() {
    return {
      showFilter: false,
      loading: true,
      transactions: [],
      search: "",
      pagination: {
        sortBy: "purchaseDate",
        descending: true,
        page: 1,
      },
      headers: [
        {
          text: "Item Details",
          value: "items[0].productName",
          sortable: false,
        },
        { text: "Spend Ovations", value: "customerName", width: "225px" },
        { text: "Transaction Date", value: "purchaseDate", width: "180px" },
      ],
      yearList: [
        (new Date().getFullYear() - 1).toString(),
        new Date().getFullYear().toString(),
      ],
      selectedYear: new Date().getFullYear().toString(),
      monthList: [
        { text: "Jan", value: "1" },
        { text: "Feb", value: "2" },
        { text: "Mar", value: "3" },
        { text: "Apr", value: "4" },
        { text: "May", value: "5" },
        { text: "Jun", value: "6" },
        { text: "Jul", value: "7" },
        { text: "Aug", value: "8" },
        { text: "Sep", value: "9" },
        { text: "Oct", value: "10" },
        { text: "Nov", value: "11" },
        { text: "Dec", value: "12" },
      ],
      selectedMonth: (new Date().getMonth() + 1).toString(),
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  methods: {
    loadUserTransactions: function () {
      this.transactions = [];
      this.pagination.totalItems = this.transactions.length;
      this.loading = true;
      axios
        .get(
          "/api/user/store/transactions/" +
            this.selectedYear +
            "/" +
            this.selectedMonth,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.transactions = response.data.storeTransactions.items;
          this.pagination.totalItems = this.transactions.length;
          this.loading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Could not retrieved store transactions.<br>Response: " +
              e.response.data.message +
              "<br>Error #KNI837",
            messageType: "error",
          });

          this.loading = false;
        });
    },
    changeYear: function () {
      this.loadUserTransactions();
    },
    changeMonth: function () {
      this.loadUserTransactions();
    },
  },
  beforeMount() {
    this.loadUserTransactions();
  },
  watch: {
    // Update the transactions list if org changed/created
    "$store.state.userSelf.currentOrg.org": function () {
      this.loadUserTransactions();
    },
  },
};
</script>